import './pagination.scss';
import { initPagination } from './pagination.core';
import { infinityScroll } from './pagination-infinity.submodule';
import { buttonLoadMore } from './pagination-button.submodule';
import './component-card-product.module';
/**
 * modules required: [buttonLoadMore || infinityScroll]
 * modules optionals (import "./component-card-product.module";)
 */
initPagination({
  modules: [infinityScroll,buttonLoadMore],
});
